import React, { Component } from 'react';
import view, { oyoFormView, borders, validation } from '../../../Enums';
import OtpComponent from './OtpComponent';
import HomeStepTwoWidget from './HomeStepTwoWidget';
import {
    hasNumber,
    hasSpecialCharacter,
    hasUpperCase,
    isNumber
} from '../../../utils/functionUtils';
import BackIcon from '../../../resources/vectors/BackIcon';
import { centerAbs } from '../BecomeAnOyoStyles';
import DropdownMenuMobile from '../../../common/DropdownMenMobileu';
import { dialCode } from '../../../partnerStyles';
import {path } from '../../../utils';

class LoginWithOtpStepTwoWidget extends Component {
    constructor(props) {
        super(props);
        this.changeOtp = this.changeOtp.bind(this);
        this.login = this.login.bind(this);
    }
    
    state = {
        otp: null,
        ph_no_border: borders.NORMAL_BORDER,
    };
    
    login = () => {
        let otpInfoAvailable = this.checkOtpInfo();
        
        if (otpInfoAvailable) {
            let loginData = {
                otp: this.state.otp,
                phone: this.props.globalData.formData.mobile_number,
                country_code: this.props.globalData.formData.dial_code,
            };
            this.props.globalActions.postLoginOtp(loginData);
        }
    };
    
    checkOtpInfo = () => {
        let otpData = this.props.globalData.otpData;
        if (path(otpData,"data.status",false))
            return true;
        return false;
    };
    
    componentDidMount() {
        this.props.setLoginFunction(this.login);
    }
    
    changeOtp = otp => {
        if (isNumber(otp)) this.setState({ otp: otp });
    };
    
    
    render() {
        let gs = this.props.gs;
        let gc = this.props.gc;
        let guc = this.props.guc;
        let gi = this.props.gi;
    
        let flagImage, dial_Code;
        flagImage = {
            ...gs('flag_style'),
            backgroundPosition: '0 -' + this.props.flagPos + 'px'
        };
        dial_Code = dialCode;
        
        return (
            <div>
                <BackIcon className={'hover'} onClick={() => {
                    this.props.changeFormScreen(oyoFormView.checkEarnings);
                }} style={gs('back')}/>
                <div style={gs('big_text_form')}>{gc('login_to_manage')}</div>
                <div
                    onClick={() => {
                        this.props.changeFormScreen(oyoFormView.loginScreen);
                    }}
                    style={{
                        ...gs('big_white_button'),
                        position: 'relative',
                        marginTop: '18px'
                    }}
                >
                    <div style={{ ...centerAbs, width: '100%' }}>
                        {gc('login_with_password')}
                    </div>
                </div>
                <div style={gs('or')}>
                    {'--------- '}{gc('OR')}{' ----------'}
                </div>
                <div style={gs('form_small_text')}>{gc('registered_mobile_number')}{'*'}</div>
    
                <div style={gs('mobile_number_container')}>
          <span
              style={gs('cursor_pointer_style')}
              className={'cursorPointer'}
              onClick={this.props.changeMobile}
          >
            <img style={gs('down_arrow_style')} src={gi('down_arrow')} />
          </span>
        
                    <span
                        style={{
                            ...flagImage,
                            ...gs('flag_image_style')
                        }}
                        className={'cursorPointer'}
                        onClick={this.props.changeMobile}
                    />
                    <input
                        placeholder={gc('mobile_number_placeholder')}
                        autoComplete="new-password"
                        onChange={this.props.onChangeMobileInput}
                        value={this.props.resultant_ph_no}
                        className={'removeFocusOutline'}
                        style={{
                            ...gs('input_form'),
                            padding: '10px 0px 10px 61px',
                            width: this.props.viewMode == view.DESKTOP ? '82%' : '86%',
                            border: this.props.ph_no_border_validated
                                ? this.state.ph_no_border
                                : borders.RED_BORDER
                        }}
                        onFocus={() => {
                            this.setState({
                                ph_no_border: borders.ACTIVE_BORDER
                            });
                        }}
                        onBlur={() => {
                            this.setState({
                                ph_no_border: borders.NORMAL_BORDER
                            });
                        }}
                    />
                    {this.props.showDropdownMobile && (
                        <DropdownMenuMobile
                            id={'locDrop'}
                            viewSize={'Desktop'}
                            k={this.props.flag}
                            topPos={'4px'}
                            divWidth={'100%'}
                            divTop={'48px'}
                        />
                    )}
                </div>
                <div style={{ ...gs('form_small_text'),marginTop:'4px' }}>
                    {guc('veri_code_otp_sent')}
                </div>
                
                <OtpComponent
                    gc={gc}
                    gs={gs}
                    guc={guc}
                    otp={this.state.otp}
                    changeOtp={this.changeOtp}
                    globalData={this.props.globalData}
                />
                
                <div
                    className={'hover'}
                    onClick={this.props.regenerateOtp}
                    style={{
                        ...gs('form_small_text'),
                        color: 'blue',
                        textDecoration: 'underline',
                        width:'fit-content'
                    }}
                >
                    {gc('regenerate_otp')}
                </div>
                
                
                
                {this.props.globalData.loginData.errorMessage && (
                    <div
                        style={{ ...gs('form_small_text'), color: 'red',marginTop:'-3px' }}
                    >
                        {this.props.globalData.loginData.errorMessage}
                    </div>
                )}
            </div>
        );
    }
}

export default LoginWithOtpStepTwoWidget;
